var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5576,2.0356l-1.5977-1.5962c-.2549-.2544-.6152-.4136-.9893-.4365-.3984-.0249-.7861.1123-1.0498.3765L1.6387,10.6558c-.0547.0547-.0967.1221-.1211.1958L.0254,15.3423c-.0596.1797-.0127.3774.1211.5112.0957.0952.2227.1465.3535.1465.0527,0,.1064-.0083.1582-.0254l4.4941-1.4971c.0732-.0249.1406-.0659.1953-.1206L15.6211,4.0967c.2646-.2642.4014-.6514.376-1.0625-.0244-.3794-.1846-.7432-.4395-.9985ZM2.7039,11.0052L10.9879,2.7256l2.2924,2.295L4.9946,13.2963l-2.2906-2.291Zm-.4903.9238l1.855,1.8553-2.7795.9256.9246-2.7809ZM14.9141,3.3887l-.9264.9253-2.2926-2.2952.9329-.9323c.0615-.0615.1562-.0879.2822-.0854.1318.0083.2598.0625.3428.1455l1.5977,1.5962c.083.0825.1396.2188.1484.355.0078.124-.0234.23-.085.291Z",
    className: "aw-theme-iconOutline",
    fill: "#464646",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3c4146ffe24f72b25319c0711557dd26.svg";
export { ForwardRef as ReactComponent };